import { UPDATE_INDEX_CARDS } from './snowflakeUpdates';

/**
 * Site-wide updates ticker. Copy and links come from the updates index, so
 * every note is announced. Dismissal is stored for the whole set: a new note
 * shows the banner again.
 *
 * The previous ticker moved one copy of a single line in 22s. This pace is
 * 27.5% faster, inside the requested 25 to 30% range. Duration grows with the
 * text so the line keeps that pace when notes are added.
 */
const PREVIOUS_LOOP_SECONDS = 22;
const SPEEDUP = 1.275;
const PAD_UNITS = 12;
const PREVIOUS_COPY =
  'Snowflake SQLAlchemy 2.0 is here, with async support and breaking changes. Pin before you upgrade.';

export const UPDATES_BANNER_SPEEDUP = SPEEDUP;
export const UPDATES_BANNER_PREVIOUS_SECONDS = PREVIOUS_LOOP_SECONDS;

/** Copies of the full entry list inside each half of the seamless loop. */
export const UPDATES_BANNER_REPEAT = 2;

export function updatesBannerEntries() {
  return UPDATE_INDEX_CARDS.map((card) => ({
    copy: card.title,
    href: card.path,
  }));
}

export function updatesBannerDismissKey(entries) {
  const signature = entries.map((entry) => `${entry.href}\n${entry.copy}`).join('\n');
  return `myorglab.updatesBanner:${signature}`;
}

export function updatesBannerDurationSeconds(entries, repeat = UPDATES_BANNER_REPEAT) {
  const previousUnits = PREVIOUS_COPY.length + PAD_UNITS;
  const groupUnits =
    entries.reduce((sum, entry) => sum + entry.copy.length + PAD_UNITS, 0) * repeat;
  const seconds = (groupUnits / previousUnits) * (PREVIOUS_LOOP_SECONDS / SPEEDUP);
  return Math.round(seconds * 10) / 10;
}
